'use client'

import { useAtom } from 'jotai'
import { useCallback } from 'react'

import { persistRefreshToken } from '@/features/auth/hooks/use-auth'
import {
  applyReissuedTokens,
  ReissuedTokenResponse,
} from '@/features/auth/lib/apply-reissued-tokens'
import { authAtom } from '@/state/auth'

// Returns an applier bound to the live authAtom + the same refresh-token
// persistence the post-login flow uses. Call it from any mutation onSuccess
// whose response may carry nuke-and-reissue tokens.
export function useApplyReissuedTokens() {
  const [authState, setAuthState] = useAtom(authAtom)

  return useCallback(
    (response: ReissuedTokenResponse) =>
      applyReissuedTokens(response, { authState, setAuthState, persist: persistRefreshToken }),
    [authState, setAuthState]
  )
}
